import React, {useState, useEffect} from 'react';
import {TitleAdmin, InputSaveBtn} from './components';
import drawAdminSection from 'function/drawAdminSection';
import {Loading} from 'components/items';
import {alertDone} from 'function/alert';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
import 'firebase/storage';
var db = firebase.firestore();
var fb_storage = firebase.storage();

// fireabse field
const COLLECTION = "home";
const DOC_MAP = "maps";
const DOC_LOGO = "logos";

const AdminHome = () => {
  // field
  const [db_map, set_db_map] = useState();
  const [nowMap, setNowMap] = useState();
  const [db_logo, set_db_logo] = useState();
  const [nowLogo, setNowLogo] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=> {
    _get();
  }, []);

  useEffect(() => {
    setNowMap(db_map);
  }, [db_map])

  useEffect(() => {
    setNowLogo(db_logo);
  }, [db_logo])

  // - method - 
  const _get = async () => {
    setIsLoading(true);
    const ref = await db.collection(COLLECTION).get()
    ref.forEach((doc) => {
      switch(doc.id){
        case DOC_MAP : {
          set_db_map(doc.data());
          break;
        }
        case DOC_LOGO : {
          set_db_logo(doc.data());
          break;
        }
        default :{
          return;
        }
      }
    });
    setIsLoading(false);
  }

  // form submit handler
  const formSubmitHandler = async (e) => {
    console.log('formSubmitHandler')
    setIsLoading(true);

    e.preventDefault();
    // console.log(isLoading);

    if(nowMap !== db_map){
      await updateMaps();
    }
    
    if(nowLogo !== db_logo){
      await updateLogos();
    }

    setIsLoading(false);
    alertDone();
  }

  // update maps to firebase
  const updateMaps = async () => {
    db.collection(COLLECTION).doc(DOC_MAP).set(nowMap)
    .then(function() {
      console.log("Document successfully written!");
      setIsLoading(false);
    })
    .catch(function(error) {
      console.error("Error writing document: ", error);
    });
  }

  // update header logo to firebase
  const updateLogos = async  () => {
    db.collection(COLLECTION).doc(DOC_LOGO).set(db_logo)
    .then(function() {
      console.log("Document successfully written!");
    })
    .catch(function(error) {
      console.error("Error writing document: ", error);
    });
  }

  const uploadFirebaseStorage = async (file, root, callback) => {
    setIsLoading(true);
    const storageRef = await fb_storage.ref(root);
    storageRef.put(file);
    const url = await storageRef.getDownloadURL();
    callback(url);
  }

  const setNewItems = (newItems, newValue, label, targetName, newUrl) => {
    // newItems.forEach
    newItems.forEach(item => {
      if(item.label===label){
        item.contents.forEach(input =>{
          if(input.name===targetName){
            
            input.value = newValue;
            return input.url = newUrl;

          }
        })
      }
    });

    setNowLogo({
      ...db_logo,
      items: newItems
    })

    setIsLoading(false);

  }

  // when input value changed
  const inputChangeHandler = (doc, label) => (e) => {
    switch(doc){
      case DOC_MAP : {
        let newItems = db_map.items;
        let newValue = e.target.value;
        
        // foreach
        newItems.forEach(item => {
          if(item.label===label){
            item.contents.forEach(input =>{
              if(input.name===e.target.name){
                input.value = +newValue;
              }
            })
          }
        });

        setNowMap({
          ...db_map,
          items: newItems
        })
        break;
      }
      case DOC_LOGO : {
        let newItems = db_logo.items;
        let newValue = e.target.files[0].name;
        const targetName = e.target.name

        // 파일 스토리지 업로드
        var file = e.target.files[0];
        const root = `${COLLECTION}/${doc}/${label}`;

        uploadFirebaseStorage(file,root, (url)=> {
          setNewItems(newItems, newValue, label, targetName, url)
        });

        break;
      }
      default : return;
    }
  } 

  return (
    <div className="AdminHome">
      <Loading className={`${isLoading ? `` : `hide`}`} />
      <div className="admin-header">
        <div className="con admin">
          <TitleAdmin title = "HOME" />
        </div>
      </div>      

      <div className="admin-contents">
        <div className="con admin">
          <form onSubmit={formSubmitHandler}>
            
            {db_map ? drawAdminSection(db_map, inputChangeHandler) : <Loading />}
            {db_logo ? drawAdminSection(db_logo, inputChangeHandler) : <Loading />}
            
            <InputSaveBtn />

          </form>
        </div>
      </div>

    </div>
  );
}



export default AdminHome;